import React, { Component } from 'react';
import { Modal, Button, Table, Tabs, Tab } from 'react-bootstrap';
import { translate } from 'react-i18next';
import Moment from 'moment';
import './AuditLogDetailModal.css';

class AuditLogDetailModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'details'
        };
    }

    copyToClipboard = () => {
        const { log } = this.props;
        const jsonString = JSON.stringify(log, null, 2);

        if (navigator.clipboard) {
            navigator.clipboard.writeText(jsonString).then(() => {
                alert('JSON copied to clipboard!');
            });
        } else {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = jsonString;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            alert('JSON copied to clipboard!');
        }
    };

    renderChanges(changes) {
        if (!changes || Object.keys(changes).length === 0) {
            return <p className="text-muted">No changes recorded</p>;
        }

        return (
            <Table bordered condensed>
                <thead>
                    <tr>
                        <th>Field</th>
                        <th>{this.props.t('AuditLogs.before')}</th>
                        <th>{this.props.t('AuditLogs.after')}</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(changes).map((key) => {
                        const change = changes[key];
                        return (
                            <tr key={key}>
                                <td><strong>{key}</strong></td>
                                <td className="change-before">
                                    {typeof change.from === 'object'
                                        ? JSON.stringify(change.from)
                                        : String(change.from || '-')}
                                </td>
                                <td className="change-after">
                                    {typeof change.to === 'object'
                                        ? JSON.stringify(change.to)
                                        : String(change.to || '-')}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        );
    }

    render() {
        const { show, onHide, log, t } = this.props;

        if (!log) {
            return null;
        }

        const timestamp = Moment(log.timestamp).format('YYYY-MM-DD HH:mm:ss');
        const actionLabel = t(`AuditLogs.actions.${log.event.action}`) || log.event.action;
        const outcomeLabel = t(`AuditLogs.outcomes.${log.event.outcome}`) || log.event.outcome;
        const entityLabel = t(`AuditLogs.entities.${log.target.type}`) || log.target.type;
        const severityLabel = t(`AuditLogs.severities.${log.event.severity}`) || log.event.severity;

        return (
            <Modal show={show} onHide={onHide} bsSize="large" className="AuditLogDetailModal">
                <Modal.Header closeButton>
                    <Modal.Title>{t('AuditLogs.detailsTitle')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tabs activeKey={this.state.activeTab} onSelect={(key) => this.setState({ activeTab: key })} id="audit-log-tabs">
                        <Tab eventKey="details" title="Details">
                            <div className="detail-section">
                                <h4>Event Information</h4>
                                <Table bordered condensed>
                                    <tbody>
                                        <tr>
                                            <td><strong>{t('AuditLogs.timestamp')}</strong></td>
                                            <td>{timestamp}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>{t('AuditLogs.action')}</strong></td>
                                            <td><span className={`label label-${log.event.action === 'delete' ? 'danger' : 'info'}`}>{actionLabel}</span></td>
                                        </tr>
                                        <tr>
                                            <td><strong>{t('AuditLogs.outcome')}</strong></td>
                                            <td><span className={`label label-${log.event.outcome === 'success' ? 'success' : 'danger'}`}>{outcomeLabel}</span></td>
                                        </tr>
                                        <tr>
                                            <td><strong>{t('AuditLogs.severity')}</strong></td>
                                            <td><span className={`label label-${log.event.severity === 'high' || log.event.severity === 'critical' ? 'danger' : 'warning'}`}>{severityLabel}</span></td>
                                        </tr>
                                        {log.event.summary && (
                                            <tr>
                                                <td><strong>Summary</strong></td>
                                                <td>{log.event.summary}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>

                            {log.context && (
                                <div className="detail-section">
                                    <h4>HTTP Request</h4>
                                    <Table bordered condensed>
                                        <tbody>
                                            {log.context.method && (
                                                <tr>
                                                    <td><strong>Method</strong></td>
                                                    <td>
                                                        <span className={`label label-${
                                                            log.context.method === 'GET' ? 'info' :
                                                            log.context.method === 'POST' ? 'success' :
                                                            log.context.method === 'DELETE' ? 'danger' :
                                                            'warning'
                                                        }`}>{log.context.method}</span>
                                                    </td>
                                                </tr>
                                            )}
                                            {log.context.path && (
                                                <tr>
                                                    <td><strong>Path</strong></td>
                                                    <td className="monospace">{log.context.path}</td>
                                                </tr>
                                            )}
                                            {log.context.query && Object.keys(log.context.query).length > 0 && (
                                                <tr>
                                                    <td><strong>Query Parameters</strong></td>
                                                    <td className="monospace">
                                                        {Object.entries(log.context.query).map(([k, v]) => (
                                                            <div key={k}>{k} = {String(v)}</div>
                                                        ))}
                                                    </td>
                                                </tr>
                                            )}
                                            {log.context.duration !== undefined && (
                                                <tr>
                                                    <td><strong>Duration</strong></td>
                                                    <td>{log.context.duration} ms</td>
                                                </tr>
                                            )}
                                            {log.context.organisationId && (
                                                <tr>
                                                    <td><strong>Organisation ID</strong></td>
                                                    <td>{log.context.organisationId}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            )}

                            <div className="detail-section">
                                <h4>{t('AuditLogs.actor')}</h4>
                                <Table bordered condensed>
                                    <tbody>
                                        <tr>
                                            <td><strong>Name</strong></td>
                                            <td>{log.actor.name || '-'}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Email</strong></td>
                                            <td>{log.actor.email || '-'}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>ID</strong></td>
                                            <td className="monospace">{log.actor.id || '-'}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Type</strong></td>
                                            <td>{log.actor.type || '-'}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>

                            <div className="detail-section">
                                <h4>{t('AuditLogs.target')}</h4>
                                <Table bordered condensed>
                                    <tbody>
                                        <tr>
                                            <td><strong>{t('AuditLogs.entityType')}</strong></td>
                                            <td>{entityLabel}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>Entity ID</strong></td>
                                            <td className="monospace">{log.target.id || '-'}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>

                            <div className="detail-section">
                                <h4>{t('AuditLogs.source')}</h4>
                                <Table bordered condensed>
                                    <tbody>
                                        <tr>
                                            <td><strong>{t('AuditLogs.ipAddress')}</strong></td>
                                            <td className="monospace">{log.source.ip || '-'}</td>
                                        </tr>
                                        <tr>
                                            <td><strong>{t('AuditLogs.userAgent')}</strong></td>
                                            <td style={{ wordBreak: 'break-word' }}>{log.source.userAgent || '-'}</td>
                                        </tr>
                                        {log.source.organisationId && (
                                            <tr>
                                                <td><strong>Organisation ID</strong></td>
                                                <td>{log.source.organisationId}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </div>

                            {log.details && log.details.changes && (
                                <div className="detail-section">
                                    <h4>{t('AuditLogs.changes')}</h4>
                                    {this.renderChanges(log.details.changes)}
                                </div>
                            )}

                            {log.details && log.details.requestId && (
                                <div className="detail-section">
                                    <h4>{t('AuditLogs.metadata')}</h4>
                                    <Table bordered condensed>
                                        <tbody>
                                            <tr>
                                                <td><strong>{t('AuditLogs.requestId')}</strong></td>
                                                <td className="monospace">{log.details.requestId}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            )}
                        </Tab>

                        <Tab eventKey="json" title={t('AuditLogs.rawJson')}>
                            <div className="json-view">
                                <Button bsSize="xs" bsStyle="primary" onClick={this.copyToClipboard} className="copy-json-btn">
                                    <i className="fa fa-copy" /> {t('AuditLogs.copyJson')}
                                </Button>
                                <pre>{JSON.stringify(log, null, 2)}</pre>
                            </div>
                        </Tab>
                    </Tabs>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={onHide}>{t('Dialog.close')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default translate('translations')(AuditLogDetailModal);
